<template>
  <CardModule title="Informações complementares">
    <v-row>
      <v-col cols="12">
        <BaseTextField
          required
          label="URL do Produto"
          placeholder="Insira o url do produto"
          v-model="$produtos_gerenciar.cadastro.pre_visualizacao.slug"
          counter
          :maxlength="65"
          type="text"
          :rules="[rules.required, rules.max(65)]"
        />
      </v-col>
    </v-row>
  </CardModule>
</template>

<script>
import mixins from "@/mixins";
import CardModule from "@/components/cards/CardModule.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";

const { products, formRules } = mixins;

export default {
  name: "AdditionalInformation",
  mixins: [products, formRules],
  components: {
    CardModule,
    BaseTextField,
  },
  watch: {
    "$produtos_gerenciar.cadastro.dados_cadastrais.descricao_pt_br"(e) {
      this.$produtos_gerenciar.cadastro.pre_visualizacao.slug =
        this.$produtos_gerenciar.transformToSlug(e);
    },
  },
};
</script>

<style scoped></style>
